import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { getChangeableGmbFields } from '../../../location-utils';
import {
  BulkActionPopupComponent,
  BulkActionPopupData,
  SelectedFieldsRadioButton,
} from '../bulk-action-popup/bulk-action-popup.component';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatIcon } from '@angular/material/icon';

interface UpdateGbpPopupData extends BulkActionPopupData {
  selectedLocationsCount: number;
}

@Component({
    selector: 'app-update-gbp-popup',
    templateUrl: './update-gbp-popup.component.html',
    styleUrls: ['../bulk-action-popup/bulk-action-popup.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatDialogTitle,
        MatIcon,
        MatDialogContent,
        MatRadioGroup,
        MatRadioButton,
        MatCheckbox,
        NgClass,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        TranslateModule,
    ],
})
export class UpdateGbpPopupComponent extends BulkActionPopupComponent implements OnInit {

  protected override readonly selectedFieldsRadios: SelectedFieldsRadioButton[] = [
    SelectedFieldsRadioButton.ALL,
    SelectedFieldsRadioButton.VISIBLE_ONLY,
    SelectedFieldsRadioButton.NONE,
  ];

  constructor(
      public dialogRef: MatDialogRef<UpdateGbpPopupComponent>,
      @Inject(MAT_DIALOG_DATA) public data: UpdateGbpPopupData,
      protected fb: FormBuilder,
  ) {
    super(data, dialogRef, fb);
  }

  override ngOnInit() {
    this.getSelectableFields = getChangeableGmbFields; // init method
    super.ngOnInit();
  }

  protected override generateResult() {
    return {
      selectedFields: this.getSelectedFieldIDs(),
    };
  }


}
